// Cut-down reimplementation of i18n client-side handler, compatible with i18n-2 sources.

const vsprintf = require('sprintf-js').vsprintf
const locales = { en: require('locales/en.json') }
const locale = 'en'

function dotNotation (obj, is, value) {
   if (obj.hasOwnProperty(is)) {
      return obj[is];
   }

   if (typeof is === 'string') {
      return dotNotation(obj, is.split('.'), value);
   } else if (is.length === 1 && value !== undefined) {
      return obj[is[0]] = value;
   } else if (is.length === 0) {
      return obj;
   } else {
      if (obj.hasOwnProperty(is[0])) {
         return dotNotation(obj[is[0]], is.slice(1), value);
      } else {
         return obj[is.join('.')] = is.join('.');
      }
   }
}

module.exports = function() {
   let singular = arguments[0]
   let msg;
   // console.log('i18n 1', arguments)
   if (!locale || !locales[locale] || !locales[locale][singular]) {
      msg = singular
   } else {
      msg = dotNotation(locales[locale], singular, undefined)
   }

   // console.log('i18n 2', msg)

   if (arguments.length > 1) {
      msg = vsprintf(msg, Array.prototype.slice.call(arguments, 1))
   }
   // console.log('i18n 3', msg)

   return msg
}
